module.exports = __webpack_public_path__ + "static/media/dataUsesWhite.99c80f9b.svg";